//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import InputField from 'components/Shared/InputField/Index'
import { useTranslation } from 'react-i18next'
import { Field } from 'react-final-form'
import { customIsEqual } from './utils'

const FieldComponent = ({
  isReadOnly,
  value,
  onChange,
  placeholder,
  maxLength,
  disabled,
  isError,
}) => {
  const { t } = useTranslation()

  if (isReadOnly) {
    return value
  }

  return (
    <InputField
      placeholder={(placeholder !== undefined) ? placeholder : t('common.typeHere')}
      value={value}
      onChange={onChange}
      maxLength={maxLength}
      showClear={!disabled}
      disabled={disabled}
      isError={isError}
    />
  )
}

FieldComponent.propTypes = {
  isReadOnly: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  isError: PropTypes.bool,
}

const TextField = ({ name, placeholder, validate, maxLength, disabled, isReadOnly }) => {
  return (
    // without custom parse empty values are not passed to onSubmit() so API doesn't get cleared strings
    // see https://github.com/final-form/react-final-form/issues/130#issuecomment-425482365
    <Field
      name={name}
      isEqual={customIsEqual}
      validate={validate}
      parse={value => (value)}
    >
      {({ input, meta }) => {
        return (
          <FieldComponent
            isReadOnly={isReadOnly}
            value={input.value}
            onChange={input.onChange}
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled}
            isError={!!meta.error?.highlight}
          />
        )
      }}
    </Field>
  )
}

TextField.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  validate: PropTypes.func,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
}

export default TextField
